// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import MotionLazyContainer from './components/animate/MotionLazyContainer';

import ws from './utils/ws';
import { setupInterceptors } from './utils/axios';
import Notifier from './utils/notifier';
import ActivityWatcher from './utils/activityWatcher';
import useAuth from "./hooks/useAuth";
import { useNavigate } from "react-router-dom";
// ----------------------------------------------------------------------

export default function App() {
  ws.init();
  const { logout } = useAuth();
  const navigateTo = useNavigate();

  setupInterceptors(navigateTo, logout);

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <NotistackProvider>
            <Notifier />
            <ActivityWatcher />
            <ProgressBarStyle />
            <ChartStyle />
            <ScrollToTop />
            <Router />
          </NotistackProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
